import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=cd60d400&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=cd60d400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd60d400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd60d400')) {
      api.createRecord('cd60d400', component.options)
    } else {
      api.reload('cd60d400', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=cd60d400&scoped=true&", function () {
      api.rerender('cd60d400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sB2zUG35Vjz7/JS/comp/CookieBox.vue"
export default component.exports